import parsePhoneNumber from 'libphonenumber-js';

export const withIntlCode = (phoneNumber: string, intlCode = 1) => {
  return phoneNumber.startsWith('+') ? phoneNumber : `+${intlCode}${phoneNumber}`;
};

const toFormattedPhoneString = (phoneNumber: string, regexp: RegExp) => {
  const match = phoneNumber.match(regexp);

  if (match) {
    const intlCode = match[1] ? `+${match[1]} ` : '';
    return [intlCode, '(', match[2], ') ', match.slice(3).join('-')].join('');
  }

  return '';
};

/**
 * Formats a phone number to (XXX) XXXX-XXXX (variable number of digits), with or without the international code.
 */
export default function formatPhoneNumber(phoneNumber: string) {
  const cleaned = ('' + phoneNumber).replace(/\D/g, '');

  // UK phone number
  if (phoneNumber?.startsWith('+44')) {
    const parsed = parsePhoneNumber(phoneNumber);
    return parsed.formatNational();
  }

  // US phone number
  return toFormattedPhoneString(cleaned, /^(1|)?(\d{3})(\d{3})(\d{4})$/);
}
